import { Slot } from '@radix-ui/react-slot';
import { type ButtonHTMLAttributes, forwardRef, type ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface BurgerMenuItemProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: ReactNode;
  title: string;
  asChild?: boolean;
}

const BurgerMenuItem = forwardRef<HTMLButtonElement, BurgerMenuItemProps>(
  ({ className, icon, title, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button';

    return (
      <Comp
        ref={ref}
        className={cn(
          'flex items-center w-full gap-3 px-3 py-2 text-left',
          'hover:bg-accent rounded cursor-pointer transition-colors',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
          'disabled:pointer-events-none disabled:opacity-50',
          className
        )}
        {...props}
      >
        {asChild ? (
          <span className="flex items-center w-full gap-3" aria-label="sign-out">
            {icon}
            <div className="text-base font-medium text-foreground">{title}</div>
          </span>
        ) : (
          <>
            {icon}
            <div className="text-base font-medium text-foreground">{title}</div>
          </>
        )}
      </Comp>
    );
  }
);

BurgerMenuItem.displayName = 'BurgerMenuItem';

export default BurgerMenuItem;
